export default __webpack_public_path__ + "static/media/geler_utilisation_de_vos_donnees.ea0922cb.jpg";